<template>
    <thead>
        <tr>
            <th
                v-for="(column, key) in columns"
                :id="'column_' + key"
                :class="{
                    'arrow arrow-down': selected.name === key && selected.direction === 'asc',
                    'arrow arrow-up': selected.name === key && selected.direction === 'desc',
                }"
                class="sortable"
                @click="$emit('click', key, selected.name === key && selected.direction === 'asc' ? 'desc' : 'asc')"
            >
                {{ column }}
            </th>
            <th v-if="deleteColumn" class="td-checkbox"></th>
        </tr>
    </thead>
</template>

<script>
    export default {
        name: 'SortableHeader',
        props: {
            columns: {
                type: Object,
                required: true,
            },
            deleteColumn: {
                type: Boolean,
                default: false,
            },
            selected: {
                type: Object,
                required: true,
            },
        },
        emits: ['click'],
    };
</script>
